<template>
    <div class="col-12 pt-2">
        <ob1-liens
            v-if="offer.backLinkDTO"
            class="mb-1"
            :href="'#'"
            :text="offer.backLinkDTO.label"
            :is-back="true"
            :with-arrow="true"
            @ob1-liens-click="handleBackLink($event)"
        />
        <h1 class="mb-0">
            {{ offer.name }}
        </h1>

        <div class="row">
            <div v-if="offer.hasBlockedVersion" class="col-12 mt-1">
                <p class="lead mb-0" data-writefontsize="">
                    <strong>{{ blockedOrNotLabel }}</strong>
                </p>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12 col-md-3 order-md-2">
                <!--/* Prix */-->
                <strong v-if="offer.discountBanner" class="ob1-tag ob1-tag-primary"> {{ offer.discountBanner }}</strong>
                <div v-if="offer.prixDTO" class="mb-1">
                    <Price
                        :price="offer.prixDTO.price"
                        :initial-price="offer.prixDTO.initialPrice"
                        :price-details="offer.prixDTO.priceDetails ? offer.prixDTO.priceDetails : undefined"
                        :show-from="offer.prixDTO.showFrom"
                        :show-by-month="offer.prixDTO.showByMonth"
                        :show-promo-duration="offer.prixDTO.showPromoDuration"
                        :show-promo-duration-first-months="offer.prixDTO.showPromoDurationFirstMonths"
                        :show-children-promotion-price="offer.prixDTO.showChildrenPromotionPrice"
                        :duration="offer.prixDTO.duration"
                        :is-cents-format="false"
                        :is-compact="false"
                        :is-inverse="false"
                    />
                </div>
                <div v-if="offer.promotionConditionsDTO.text">
                    <ob1-liens-haut-bas
                        class="mb-1"
                        button-id="promo-link"
                        collapsed-block-id="promo-conditions"
                        :button-label="offer.promotionConditionsDTO.title"
                        :is-mini="false"
                    >
                        <p class="mb-0" v-html="offer.promotionConditionsDTO.text" />
                    </ob1-liens-haut-bas>
                </div>
                <div v-if="offer.openMessage" class="mb-3">
                    <ob1-separateur color="gray3" />
                    <div class="d-flex align-items-center py-1">
                        <div class="flex-shrink-0">
                            <span class="icon icon-phone-fund-euro font-size-24 me-1 text-dark" />
                        </div>
                        <div class="flex-grow-1">
                            <strong><span v-html="offer.openMessage" /></strong>
                        </div>
                    </div>
                    <ob1-separateur color="gray3" />
                </div>
            </div>

            <div id="choose-links" class="col-12 col-md-5 pb-1 order-md-3">
                <div class="d-flex flex-column">
                    <!--/* CTA Choisir ce forfait */-->
                    <template v-if="offer.addOfferDto">
                        <p class="fw-bold mb-0">
                            {{ newClientLabel }}
                        </p>
                        <span class="visually-hidden">{{ offerNameAccessibility }}</span>
                        <ob1-boutons
                            v-if="offer.addOfferDto.link"
                            class="mb-2"
                            :is-button="false"
                            :label="offer.addOfferDto.label"
                            :is-primary="true"
                            :data-oevent-category="'fiche_forfait'"
                            :data-oevent-action="offer.addOfferDto.label"
                            :data-oevent-label="'vers_tunnel'"
                            :href="offer.addOfferDto.link"
                        />

                        <offer-cta-with-device-popin
                            v-else-if="offer.addOfferDto.popinWithDeviceDto"
                            class="mb-2"
                            :is-primary="true"
                            :label="offer.addOfferDto.label"
                            :offer-name="offer.name"
                            :popin-id="'addOfferWithDevicePopIn'"
                            :popin-ctas-dto="offer.addOfferDto.popinWithDeviceDto"
                            :tracking-category="'fiche_forfait'"
                            :tracking-label="'vers_popin'"
                        />

                        <offer-cta-with-delivery-popin
                            v-else
                            class="mb-2"
                            :is-primary="true"
                            :label="offer.addOfferDto.label"
                            :popin-id="'addOfferAllDisponibilitiesPopIn'"
                            :popin-ctas-dto="offer.addOfferDto.popinDeliveryDto"
                            :advantage-messages="advantageMessages"
                            :advantage-values="offer.advantageValues"
                            :is-online-recovery-available="isOnlineRecoveryAvailable"
                            :offer-name="offer.name"
                            :tracking-category="'fiche_forfait'"
                            :tracking-label="'vers_popin'"
                        />
                    </template>

                    <!--/* CTA Ajouter ce forfait */-->
                    <template v-if="offer.addOfferWithAuthenticationDto">
                        <p v-if="offer.addOfferDto != null" class="fw-bold mb-0">
                            {{ alreadyClientLabel }}
                        </p>

                        <span class="visually-hidden">{{ offerNameAccessibility }}</span>
                        <ob1-boutons
                            v-if="offer.addOfferWithAuthenticationDto.link"
                            class="mb-2"
                            :is-button="false"
                            :label="offer.addOfferWithAuthenticationDto.label"
                            :is-primary="offer.addOfferDto == null"
                            :is-secondary="offer.addOfferDto != null"
                            :data-oevent-category="'fiche_forfait'"
                            :data-oevent-action="offer.addOfferWithAuthenticationDto.label"
                            :data-oevent-label="'vers_tunnel'"
                            :href="offer.addOfferWithAuthenticationDto.link"
                        />

                        <offer-cta-with-device-popin
                            v-else-if="offer.addOfferWithAuthenticationDto.popinWithDeviceDto"
                            class="mb-2"
                            :is-primary="offer.addOfferDto == null"
                            :label="offer.addOfferWithAuthenticationDto.label"
                            :offer-name="offer.name"
                            :popin-id="'addOfferWithAuthenticationAndDevicePopIn'"
                            :popin-ctas-dto="offer.addOfferWithAuthenticationDto.popinWithDeviceDto"
                            :tracking-category="'fiche_forfait'"
                            :tracking-label="'vers_popin'"
                        />

                        <offer-cta-with-delivery-popin
                            v-else
                            class="mb-2"
                            :is-primary="offer.addOfferDto == null"
                            :label="offer.addOfferWithAuthenticationDto.label"
                            :popin-id="'addOfferWithAuthenticationAllDisponibilitiesPopIn'"
                            :popin-ctas-dto="offer.addOfferWithAuthenticationDto.popinDeliveryDto"
                            :advantage-messages="advantageMessages"
                            :advantage-values="offer.advantageValues"
                            :is-online-recovery-available="isOnlineRecoveryAvailable"
                            :offer-name="offer.name"
                            :tracking-category="'fiche_forfait'"
                            :tracking-label="'vers_popin'"
                        />
                    </template>

                    <!--/* CTA Changer pour ce forfait */-->
                    <ob1-boutons
                        v-if="offer.changeOfferDto"
                        :is-button="false"
                        :label="offer.changeOfferDto.label"
                        :is-secondary="true"
                        :data-oevent-category="'fiche_forfait'"
                        :data-oevent-action="offer.changeOfferDto.label"
                        :data-oevent-label="'validation offre'"
                        :href="offer.changeOfferDto.link"
                    />

                    <!--/* CTA selection d'offre pour le internet et mobile IPLUSM */-->
                    <ob1-boutons
                        v-if="offer.selectedOfferButtonDTO"
                        :is-button="false"
                        :label="offer.selectedOfferButtonDTO.label"
                        :is-primary="true"
                        :data-oevent-category="'fiche_forfait_iplusm'"
                        :data-oevent-action="'retour_aux_offres'"
                        :data-oevent-label="'vers_retour_aux_offres'"
                        :href="getSelectedOfferUrl"
                    />
                </div>
            </div>
            <!--/* Attributes */-->
            <div id="offer-details-attributes" class="col-12 col-md-4 order-md-1 mt-2 mt-md-0">
                <h4 v-if="offer.shortDescription" class="mb-1" v-html="offer.shortDescription" />
                <ob1-item-list :item-list-d-t-o="offer.attributes" />

                <ob1-message-alerte
                    v-if="infoOptions"
                    class="row"
                    :is-simple-alerte="false"
                    type="info"
                    :title="infoOptions.title"
                    :liste-a-puces-dto="infoOptions.textsWithBulleted"
                    :texts="infoOptions.texts"
                    :with-arrow-link="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import OfferCtaWithDevicePopin from "./OfferCtaWithDevicePopin.vue";
import OfferCtaWithDeliveryPopin from "./OfferCtaWithDeliveryPopin.vue";
import Price from "../../../common/components/ob1/Price.vue";

export default {
    name: "Offer",
    components: {
        Price,
        OfferCtaWithDevicePopin,
        OfferCtaWithDeliveryPopin
    },
    props: {
        offer: {
            type: Object,
            required: true
        },
        blockedOrNotLabel: {
            type: String,
            required: true
        },
        newClientLabel: {
            type: String,
            required: true
        },
        alreadyClientLabel: {
            type: String,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        infoOptions: {
            type: Object,
            required: false,
            default: null
        },
        isOnlineRecoveryAvailable: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        getSelectedOfferUrl() {
            const vitrineHashTagParam = getUrlParam(window.location, 'vitrineHashTag');
            const selectedOfferUrl = updateUrlWithParam(this.offer.selectedOfferButtonDTO.link, 'offreMobile', this.offer.idSeo);
            return vitrineHashTagParam ? selectedOfferUrl + '#' + vitrineHashTagParam : selectedOfferUrl;
        },
        offerNameAccessibility() {
            let offerNameAccessibility = this.offer.name
                ? this.offer.name
                    .replace(/Mo/g, ' méga Octet')
                    .replace(/Go/g, ' giga Octet')
                : '';
            return "Choisir le forfait " + offerNameAccessibility;
        }
    },
    methods: {
        handleBackLink(event) {
            event.preventDefault();
            const target = this.offer.backLinkDTO.forcedBackUrlMobileOffersShowcase ? this.offer.backLinkDTO.referer : this.offer.backLinkDTO.link;
            Tms.link({category: 'fiche_forfait_mobile', action: 'retour_aux_offres', label: target});
            if (this.offer.backLinkDTO.forcedBackUrlMobileOffersShowcase) {
                history.back();
            } else
                window.location = this.offer.backLinkDTO.link;
        },
    }
}
</script>
